import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions, authSelectors } from 'redux/auth';
import { userActions } from 'redux/user';

const MIN_INTERVAL = 30 * 1000;

// Changes made while the app sat in the background, like an approval or a new role, reach it when it comes back
const useRefreshOnResume = () => {

  const dispatch = useDispatch();
  const isLoggedIn = useSelector(authSelectors.getUserIsLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      return undefined;
    }

    let refreshedAt = Date.now();

    const refresh = () => {
      if (document.visibilityState === 'hidden' || Date.now() - refreshedAt < MIN_INTERVAL) {
        return;
      }

      refreshedAt = Date.now();
      dispatch(authActions.getMember());
      dispatch(userActions.getBadges());
    };

    // Cordova announces a return to the foreground with resume, browsers with visibilitychange
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('resume', refresh);

    return () => {
      document.removeEventListener('visibilitychange', refresh);
      document.removeEventListener('resume', refresh);
    };
  }, [dispatch, isLoggedIn]);
};

export default useRefreshOnResume;
